<template>
<div :style="width">
  <div v-if="$slots.search !== undefined" :style="width">
    <slot name="search" />
  </div>
  <!-- 0305 border-right:1px solid #e0e0e0 삭제 -->
  <div v-if="autoScroll" :style="isCheckboxTree ? `${width}` : width">
    <el-scrollbar class="bar-visible" :style="isCheckboxTree ? 'margin-right: -1px;' : ''">
      <!-- 0305 style 수정 -->
      <div :style="isCheckboxTree ? 'margin-bottom: 17px;' : ''">
        <slot name="tree" />
      </div>
    </el-scrollbar>
  </div>
  <div v-else>
    <slot name="tree"/>
  </div>
</div>
</template>

<script>
export default {
  name: 'WTreeLayout',
  props: {
    autoScroll: {
      type: Boolean,
      default: false,
    },
    isCheckboxTree: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    width() {
      return this.autoScroll ? 'width: 100%;' : '';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/components/TreeLayout.vue